import { withProps } from 'recompose';
import MatrixQuestion from './MatrixQuestion';
import MatrixScaleGroupField from './matrixTable/taker/MatrixScaleGroupField';

export default withProps({
  inputRowField: MatrixScaleGroupField,
})(MatrixQuestion);
